import type {
  CsvWidgetExportAdditionalParams,
  CsvWidgetExportSource,
  ForwardCurveAdditionalParams
} from '@/features/DataHub/modules/Export/types/context.types';

type SourceBackedDataExportLike = {
  additionalParams?: CsvWidgetExportAdditionalParams | ForwardCurveAdditionalParams;
  sourceSettings?: {
    source: CsvWidgetExportSource;
    from?: string | null;
    to?: string | null;
    tabName?: string;
  };
};

export const SOURCE_BACKED_DATA_ALL_RANGE = 'all';

export const buildSourceBackedDataExportAdditionalParams = (
  source: CsvWidgetExportSource
): CsvWidgetExportAdditionalParams => {
  if (source.sourceType === 'query') {
    return {
      type: 'source-backed-data',
      queryFileId: source.queryFileId,
      selectedRange: source.selectedRange ?? null
    };
  }

  return {
    type: 'source-backed-data',
    fileName: source.fileName,
    groupName: source.groupName
  };
};

export const resolveSourceBackedDataExportSource = (
  value: SourceBackedDataExportLike | null | undefined
): CsvWidgetExportSource | undefined => {
  if (value?.sourceSettings?.source) {
    return value.sourceSettings.source;
  }

  const params = value?.additionalParams;
  if (!params || !('type' in params)) return undefined;

  if (params.queryFileId) {
    return {
      sourceType: 'query',
      queryFileId: params.queryFileId,
      selectedRange: params.selectedRange ?? null
    };
  }

  if (params.fileName && params.groupName) {
    return {
      sourceType: 'datalake',
      fileName: params.fileName,
      groupName: params.groupName
    };
  }

  return undefined;
};

export const normalizeSourceBackedDataExportFrom = (
  from?: string | null,
  to?: string | null
): string | null => {
  if (from === SOURCE_BACKED_DATA_ALL_RANGE) {
    return SOURCE_BACKED_DATA_ALL_RANGE;
  }

  if (from) {
    return from;
  }

  if (to == null) {
    return SOURCE_BACKED_DATA_ALL_RANGE;
  }

  return null;
};

export const hasSourceBackedDataExportDateFilter = (
  from?: string | null,
  to?: string | null
): boolean => Boolean((from && from !== SOURCE_BACKED_DATA_ALL_RANGE) || to);
